interface KakaoEmoticonProps {
  itemId: string;
  resourceId: number;
  itemSubType: number;
}

/**
 * 카카오 이모티콘 소스 마크업을 그려준다. 이 마크업은 Kakao.Emoticon.update('kakao_emoticon') 호출에 의해 실제 이모티콘 마크업으로 변환된다.\
 * kakao_emoticon 클래스 이름은 변경 가능. 다른 클래스 이름은 SDK 와 긴밀히 연결되어있어 변경 불가능.
 * 참고 : https://wiki.daumkakao.com/pages/viewpage.action?pageId=507649073#id-4)JavascriptSDK%EC%A0%81%EC%9A%A9%EA%B0%80%EC%9D%B4%EB%93%9C-JS
 */
export default function KakaoEmoticon({
  itemId,
  resourceId,
  itemSubType,
}: KakaoEmoticonProps) {
  return (
    // 포인터 이벤트를 막지 않으면 hover 시 '아이템 상세 보기' 툴팁이 뜨고, 클릭 시 이모티콘 사이트로 이동하게 된다.
    // eslint-disable-next-line tailwindcss/no-custom-classname
    <div className="kakao_emoticon e_cover pointer-events-none">
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src="//mk.kakaocdn.net/dn/emoticon/static/images/sdk/no_img.png"
        /* 정상적인 상황에서는 일어나지 않을 일이나,
         서버에서 resourceId를 정상적으로 주지 않을 때 이모티콘 SDK에서 스크립트 에러가 발생해
         에러 페이지로 보이는 현상을 보안 검수 중 발견해서 방어코드 추가 */
        data-id={itemId || ''}
        data-idx={resourceId || ''}
        data-type={itemSubType || ''}
        width="70"
        height="70"
        // eslint-disable-next-line tailwindcss/no-custom-classname
        className="thumb_img"
        alt=""
      />
    </div>
  );
}
